// extracted by mini-css-extract-plugin
module.exports = {"baseCheckbox":"Checkbox_baseCheckbox__11jWn","noLockWhenDisabled":"Checkbox_noLockWhenDisabled__2wEaB","small":"Checkbox_small__19pKr","restricted":"Checkbox_restricted__3ZMzX"};